import { useSelector } from "react-redux";

export const ANALYSIS_FEATURES = {
  ANALYSIS_DAP: "analysis-dap",
};

export const FEATURES = {
  EXPLORE: "explore",
  ...ANALYSIS_FEATURES,
};

export function hasFeature(feature) {
  return [feature].flat();
}

export function useFeature(feature) {
  return hasFeature(feature);
}
